module.exports = __webpack_public_path__ + "img/user_attributes.8894b231.svg";